import { useQuery } from '@tanstack/react-query';
import type { UseQueryOptions, UseQueryResult } from '@tanstack/react-query';
import { isServer } from '../../utils/utils';
import type { AdhElement } from '../../types/extend';

export const useExtendGetOffers = (
    productId?: string,
    options?: UseQueryOptions<AdhElement[]>,
): UseQueryResult<AdhElement[]> =>
    useQuery({
        queryKey: ['EXTEND.offers', productId],
        queryFn: () => {
            if (!productId) {
                return undefined;
            }

            return window.Extend?.getOffer({ referenceId: productId });
        },
        enabled: !isServer && !!window.Extend && !!productId && !!options?.enabled,
        select: (data) => data?.plans?.adh ?? [],
    });
